export default __webpack_public_path__ + "static/media/userDefault.350a208c.png";